import type { BillingPlan } from '@recruitee/products-types';
import type { PaymentInterval, PricingFeatureSubscription } from '@recruitee/subscription-types';

export const getInitialChargebeeInterval = (
  subscription: PricingFeatureSubscription,
  assignedProduct?: BillingPlan,
): PaymentInterval => {
  if (assignedProduct?.billingPeriod) return assignedProduct?.billingPeriod;
  if (subscription?.billingPeriod) return subscription?.billingPeriod;
  return 12;
};
